import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { isBrowser } from 'ws-scripts/modules/environment';
import './VehicleMedia.scss';

const VehicleMedia = ({ vehicleTitle }) => {
	const pubsub = isBrowser && window?.DDC?.pubsub;
	const altText = vehicleTitle?.length > 0 ? vehicleTitle.join(' ') : '';

	const [imageUrl, setImageUrl] = React.useState(null);

	useEffect(() => {
		if (pubsub) {
			pubsub.subscribe('ws-vehicle-toolbar/show-image', (url) => {
				setImageUrl(url);
			});
		}
		return () => {
			pubsub.unsubscribe('ws-vehicle-toolbar/show-image');
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		imageUrl && (
			<img
				alt={altText}
				src={imageUrl}
				className="ws-vehicle-toolbar-image-thumbnail mr-4"
			/>
		)
	);
};

export default VehicleMedia;

VehicleMedia.propTypes = {
	vehicleTitle: PropTypes.arrayOf(PropTypes.string)
};
